import { render } from "./preparePackage.vue?vue&type=template&id=e8088082&scoped=true"
import script from "./preparePackage.vue?vue&type=script&lang=js"
export * from "./preparePackage.vue?vue&type=script&lang=js"

import "./preparePackage.vue?vue&type=style&index=0&id=e8088082&lang=scss&scoped=true"
import "./preparePackage.vue?vue&type=style&index=1&id=e8088082&lang=scss"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8088082"]])

export default __exports__